
import Tween from "tween.ts";
import Animation from "../../animation/Animation";
import { shortestAngleDifference } from "../../utils/math/shortestAngleDifference";

export default class MovePointAnimation extends Animation {
  private Anim = Animation.getInstance();
  private isStopped = false;
  constructor(sRadian: number, radian: number, onUpdate: (a: number) => void, onComp: () => void, resolve: () => void) {
    super();
    
    if(this.Anim.getIsCancelled()) {
      resolve()
      return 
    };

    const target = shortestAngleDifference(sRadian, radian) + sRadian;
    const a = { radian: sRadian }
    new Tween.Tween({ ...a })
      .to({ radian: target }, 1200)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((a) => {
        const isCancelled =  this.Anim.getIsCancelled();
        if(isCancelled) {
          this.isStopped = true;
          onComp();
        }
        if(!this.isStopped){
           onUpdate(a.radian);
        };
      })
      .onComplete(() => onComp())
      .start();
  }
}